import React, { useEffect, useState } from 'react'
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { Chip, FormControl, FormHelperText, Grid, LinearProgress, MenuItem, Select, SelectProps, Stack, Box, Typography, Paper, IconButton, Button } from '@mui/material';
import { taxesandfeesModel, UsersModel_VS } from '../../models/TaxesAndFeesModel'
import { FieldAttributes, Form, Formik, useField } from 'formik';
import { FMSelectRateTypeField } from '../Elements/select';
import { FMTextField } from '../Elements/input';
import useAuth from "../../context/AuthProvider";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import Swal from 'sweetalert2';
import CancelIcon from "@mui/icons-material/Cancel";
import { apiClient } from '../../helper/api';

const selectFieldSx = {
  width: '100%',
  '& .MuiSelect-select': { padding: '14.5px 16px' },
  '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' },
};
const textFieldSx = {
  '& .MuiOutlinedInput-notchedOutline': { border: '2px solid #e2e8f0 !important', borderRadius: '8px !important' },
  '& .MuiInputBase-input': { padding: '3px 14px !important' },
  '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: 'rgba(0, 0, 0, 0.87) !important' },
  '& .Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#1976d2 !important' }
};

interface Iprops {
  taxesandfessCL: taxesandfeesModel;
  handleClose: () => void;
  Open: boolean;
  initValues: taxesandfeesModel;
  fetchLOBData: (stateId: string) => void;
  LineOfBusiness: { id: number; businessCode: string; }[];
  setSelectedMultiLOB: React.Dispatch<React.SetStateAction<string | string[]>>;
  SelectedMultiLOB: string[] | string;
}

export const AddEditTaxesAndFees: React.FC<Iprops> = ({ handleClose, Open, taxesandfessCL, initValues, LineOfBusiness, fetchLOBData, setSelectedMultiLOB, SelectedMultiLOB }) => {
  const initialValues: taxesandfeesModel = initValues ? taxesandfessCL : initValues;
  const { user } = useAuth();
  const token = user?.token;
  const [TaxandFees, setTaxandFees] = useState<(string | { policyFilingTypeName?: string; taxName?: string; name?: string })[]>([]);
  const initialStatedata = { stateId: 0, stateName: "" };
  const [States, setStates] = useState([initialStatedata]);
  const [loading, setloading] = useState(false);
  const [taxFeesLoading, setTaxFeesLoading] = useState(true);
  
  function fetchStateData() {
    apiClient("/States/getStates", {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
    .then((responseJson) => {
      if (responseJson?.data != null) {
        setStates(responseJson.data);
      }
    })
  };

  const fetchData = () => {
    setTaxFeesLoading(true);
    
    apiClient(`/PolicyFilingType/GetAllTaxandFeeName`, {
      method: "GET",
      headers: new Headers({
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      }),
    })
    .then((responseJson) => {
      if (responseJson?.data != null && responseJson.data.length > 0) {
        setTaxandFees(responseJson.data);
        setTaxFeesLoading(false);
      } else {
        return apiClient(`/TaxesAndFees/GetAllTaxandFeeName`, {
          method: "POST",
          headers: new Headers({
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          }),
          body: JSON.stringify({
            StateId: 0,
          }),
        });
      }
    })
    .then((responseJson) => {
      if (responseJson && responseJson.data != null) {
        setTaxandFees(responseJson.data);
      }
    })
    .catch((error) => {
      console.error('Error fetching tax and fees data:', error);
    })
    .finally(() => {
      setTaxFeesLoading(false);
    })
  };

  useEffect(() => {
    fetchData();
    fetchStateData();
  }, []);

  const FMSelectTaxAndFeesustom: React.FC<FieldAttributes<SelectProps>> = ({
    variant,
    ...props
  }) => {
    const [field, meta] = useField<{}>(props);
    const errorText = meta.error && meta.touched ? meta.error : "";

    return (
      <FormControl error={!!errorText} fullWidth>
        <FormHelperText className="formtexthelper-heading">Tax and Fees</FormHelperText>
        <Select
          {...field}
          labelId="TaxAndFees-Select-Label"
          label={null}
          className="border-round"
          IconComponent={ExpandMoreIcon}
          displayEmpty
          disabled={taxFeesLoading}
          sx={selectFieldSx}
        >
          <MenuItem value="">
            {taxFeesLoading ? 'Loading...' : 'Select Tax'}
          </MenuItem>
           {TaxandFees && TaxandFees.length > 0 ? TaxandFees.map((taxandfees, key) => {
             const taxName = typeof taxandfees === 'string' 
               ? taxandfees 
               : (taxandfees as any)?.policyFilingTypeName || (taxandfees as any)?.taxName || (taxandfees as any)?.name || '';
             const taxValue = typeof taxandfees === 'string' 
               ? taxandfees 
               : (taxandfees as any)?.policyFilingTypeName || (taxandfees as any)?.taxName || (taxandfees as any)?.name || '';
             
             return (
               <MenuItem key={key} value={taxValue}>
                 {taxName}
               </MenuItem>
             );
           }) : !taxFeesLoading && (
             <MenuItem disabled>
               No tax options available
             </MenuItem>
           )}
        </Select>
        <FormHelperText>{errorText}</FormHelperText>
      </FormControl>
    );
  };

  const FMSelectLineOfBusinessCustom: React.FC<FieldAttributes<SelectProps>> = ({
    variant,
    ...props
  }) => {
    const [field, meta] = useField<{}>(props);
    const errorText = meta.error && meta.touched ? meta.error : "";

    return (
      <React.Fragment>
        <FormControl error={!!errorText} fullWidth>
          <FormHelperText className="formtexthelper-heading">Select Line Of Business</FormHelperText>
          <Select
            {...field}
            labelId="LOB-Select-Label"
            label={null}
            className="border-round"
            IconComponent={ExpandMoreIcon}
            value={field.value || "" || 0}
            sx={selectFieldSx}
          >
            <MenuItem value={"ALL"}>ALL</MenuItem>
            {LineOfBusiness.map((LineOfBusiness, key) => (
              <MenuItem key={key} value={LineOfBusiness.id}>
                {LineOfBusiness.businessCode}{" "}
              </MenuItem>
            ))}
          </Select>
          <FormHelperText>{errorText}</FormHelperText>
        </FormControl>
      </React.Fragment>
    );
  };

  return (
    <Dialog
      open={Open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          width: '90%',
          maxWidth: 900,
          borderRadius: 2,
          boxShadow: '0 24px 48px rgba(0,0,0,0.12)',
        },
      }}
      sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
    >
      {loading && <LinearProgress sx={{ flexShrink: 0 }} />}
      <Formik initialValues={initialValues}
        validateOnChange={true}
        validationSchema={UsersModel_VS}
        onSubmit={(data, { setSubmitting, setErrors }) => {
          setloading(true);

          data.commaSeparatedLOBIds = SelectedMultiLOB.toString();
          // CreatedBy / LastEditBy are set server-side from the authenticated user (SOX); do not send from client.
          apiClient('/TaxesAndFees/UpdateCopy',
            {
              method: 'POST',
              headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
              }),
              body: JSON.stringify(data)
            })
            .then((res) => {
              if (!res) return
              setloading(false);
              if (res.resp === 0) {
                Swal.fire({
                  title: res.message,
                  text: "",
                  icon: "success",
                  confirmButtonText: "OK",
                });
              }
              handleClose()
              setSubmitting(true)
            }).catch((error) => {
              setloading(false);
              console.log(error)
            });
        }} >
        {({ values, isSubmitting, errors, setFieldValue }) => (<>
          
            <DialogTitle
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 1,
                py: 2,
                px: 3,
                background: 'linear-gradient(135deg, #0d4a63 0%, #15607a 100%)',
                color: '#fff',
                boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
              }}
            >
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <ReceiptLongOutlinedIcon sx={{ fontSize: 28, opacity: 0.95 }} />
                <Typography component="span" variant="h6" sx={{ fontWeight: 600, letterSpacing: '0.02em' }}>
                  Taxes and Fees
                </Typography>
              </Box>
              <IconButton
                onClick={handleClose}
                sx={{ color: 'rgba(255,255,255,0.9)', '&:hover': { color: '#fff', backgroundColor: 'rgba(255,255,255,0.12)' } }}
                aria-label="Close dialog"
              >
                <CloseOutlinedIcon />
              </IconButton>
            </DialogTitle>
            <Form className='main-form'>
            <DialogContent sx={{ width: '100%', overflow: 'auto', px: { xs: 2, sm: 3 }, py: 3 }}>
              <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, borderColor: 'divider', backgroundColor: 'grey.50', mt: 3 }}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={6}>
                    <FormControl error={!!errors.stateId} fullWidth>
                      <FormHelperText className="formtexthelper-heading">State</FormHelperText>
                      <Select
                        value={initialValues.stateId}
                        id="test-select-label"
                        label={null}
                        onChange={(e) => {
                          setFieldValue("stateId", e.target.value);
                          initialValues.stateId = Number(e.target.value);
                          fetchLOBData(String(e.target.value));
                        }}
                        name="stateId"
                        className="border-round"
                        IconComponent={ExpandMoreIcon}
                        displayEmpty
                        sx={selectFieldSx}
                      >
                        <MenuItem key={0} value={0}>
                          Select State
                        </MenuItem>
                        {States.map((state, key) => (
                          <MenuItem key={key} value={state.stateId}>
                            {state.stateName}
                          </MenuItem>
                        ))}
                      </Select>
                      <FormHelperText error>{errors.stateId}</FormHelperText>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <FMSelectTaxAndFeesustom autoWidth={true} name="taxName" />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <FMSelectRateTypeField autoWidth={true} name="ratetype" />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <FormHelperText className="formtexthelper-heading">Rate</FormHelperText>
                      <FMTextField
                        name="rate"
                        autoFocus
                        label={null}
                        type="text"
                        fullWidth
                        variant="outlined"
                        sx={textFieldSx}
                      />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <FormHelperText className="formtexthelper-heading">Payable To</FormHelperText>
                      <FMTextField name="payableto" margin="dense" label={null} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <FormHelperText className="formtexthelper-heading">Effective Date</FormHelperText>
                      <FMTextField name="effectiveDate" margin="dense" label={null} type="date" InputLabelProps={{ shrink: true }} fullWidth variant="outlined" sx={textFieldSx} />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <FormHelperText className="formtexthelper-heading">LOB</FormHelperText>
                      <Select
                        disabled={!(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer"))}
                        label={null}
                        name="Lob"
                        multiple
                        IconComponent={ExpandMoreIcon}
                        value={SelectedMultiLOB}
                        onChange={(e) => {
                          setSelectedMultiLOB(e.target.value);
                        }}
                        sx={selectFieldSx}
                        renderValue={(selected) => (
                          <Stack gap={1} direction="row" flexWrap="wrap">
                            {selected.toString().split(',').map((value) => (
                              <Chip
                                key={value}
                                label={LineOfBusiness.find(x => x.id.toString() === value)?.businessCode == undefined ? 'ALL' : LineOfBusiness.find(x => x.id.toString() === value)?.businessCode}
                                onDelete={() => setSelectedMultiLOB(SelectedMultiLOB?.toString().split(',').filter((item) => item !== value))}
                                disabled={!(user?.userRoles.split(",").includes("Super Admin") || user?.userRoles.split(",").includes("MISC Filer"))}
                                deleteIcon={<CancelIcon onMouseDown={(event) => event.stopPropagation()} />}
                              />
                            ))}
                          </Stack>
                        )}
                      >
                        <MenuItem value={"ALL"}>ALL</MenuItem>
                        {LineOfBusiness.map((Role, key) => (
                          <MenuItem key={key} value={Role.id.toString()}>{Role.businessCode}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>

                  <Grid item xs={12} sm={6}>
                    <FormControl fullWidth>
                      <FormHelperText className="formtexthelper-heading">Tax Payee</FormHelperText>
                      <FMTextField name="taxPayee" margin="dense" label={null} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                    </FormControl>
                  </Grid>

                  <Grid item xs={12}>
                    <FormControl fullWidth>
                      <FormHelperText className="formtexthelper-heading">Notes</FormHelperText>
                      <FMTextField name="notes" margin="dense" multiline rows={3} label={null} type="text" fullWidth variant="outlined" sx={textFieldSx} />
                    </FormControl>
                  </Grid>
                </Grid>
              </Paper>
            </DialogContent>

            <DialogActions
              sx={{
                px: 3,
                py: 2,
                gap: 1.5,
                borderTop: 1,
                borderColor: 'divider',
                backgroundColor: 'grey.50',
                flexWrap: 'wrap',
              }}
            >
              <Button
                variant="outlined"
                size="medium"
                onClick={handleClose}
                startIcon={<CloseOutlinedIcon />}
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  borderColor: '#e2e8f0',
                  color: '#475569',
                  '&:hover': {
                    borderColor: '#2099d2',
                    backgroundColor: '#2099d214',
                    color: '#2099d2',
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                size="medium"
                type="submit"
                disabled={isSubmitting}
                sx={{
                  textTransform: 'none',
                  fontWeight: 600,
                  backgroundColor: '#2099d2',
                  '&:hover': { backgroundColor: '#176990' },
                  px: 2.5,
                }}
              >
                Submit
              </Button>
            </DialogActions>
          </Form>
        </>)}
      </Formik>
    </Dialog>
  )
}
